import { render, staticRenderFns } from "./ShowCardsDialog.vue?vue&type=template&id=266ace96"
import script from "./ShowCardsDialog.vue?vue&type=script&lang=js"
export * from "./ShowCardsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports